module.exports = __webpack_public_path__ + "img/grading_success.fc3d0f17.png";